// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1Q7R8","image":"styles_image__27gF9"};